import React from "react";
import HeroSection from "./HomeComponents/HeroSection";
import CallToActionSection from "./HomeComponents/CallToActionSection";
import ServicesAreaSection from "./HomeComponents/ServicesAreaSection";
import AdvertisingSection from "./HomeComponents/AdvertisingSection";
import TestimonialsSection from "./HomeComponents/TestimonialsSection";


import AboutMe from "./HomeComponents/AboutMe"

const Home = () => {
  return (
    <main>
      <HeroSection />
      <AdvertisingSection />
      <CallToActionSection />
      <ServicesAreaSection />
      <TestimonialsSection />
    </main>
  );
};

export default Home;